"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colours = void 0;
exports.colours = {
    alabaster: "#f0f0f0",
    alert50: "#fff9ea",
    aqua100: "#d9f0ed",
    aqua200: "#8dd3c9",
    aqua400: "#41b6a5",
    aqua500: "#359486",
    black: "#000000",
    blue100: "#d6d7dc",
    blue300: "#858895",
    blue800: "#34384f",
    blue900: "#292d41",
    charcoal: "#3b3b3b",
    cyan100: "#ccecf9",
    cyan200: "#66c5ee",
    cyan300: "#33b2e9",
    cyan400: "#009fe3",
    cyan500: "#0072b0",
    cyan600: "#005b8c",
    cyan700: "#004b73",
    error50: "#fbebe9",
    error400: "#d6001c",
    magenta100: "#f2cfdb",
    magenta200: "#d97094",
    magenta400: "#bf104d",
    magenta500: "#940c3b",
    orange100: "#fad8cf",
    orange200: "#f08970",
    orange400: "#e63b11",
    orange500: "#ad2c0c",
    pearl: "#f7f7f7",
    purple100: "#e5cfe0",
    purple200: "#b26ea1",
    purple300: "#8985d6",
    purple400: "#7f0e62",
    purple500: "#940c3b",
    slate: "#6f6f6f",
    storm: "#cccccc",
    success50: "#eaf6ed",
    success400: "#009a44",
    teal100: "#d2e4e8",
    teal200: "#79adbb",
    teal400: "#006781",
    teal500: "#005064",
    white: "#ffffff",
    yellow100: "#fff4d5",
    yellow200: "#ffdd80",
    yellow400: "#ffc72c",
    brandBackgroundRed: "#b30510",
    brandBackgroundGreen: "#468257",
    brandRed: "#d73225",
    brandRedInter: "#d10513",
    brandRedInterFocus: "#b30510",
    brandRed300: "#fd543e",
    icopalBlue: "#0085cf",
    icopalBlueInter: "#0077ba",
    icopalBlueInterFocus: "#00639b",
    royalBlue: "#004f9f",
    royalBlueFocus: "#003d7a",
    navyBlue: "#133579",
    navyBlueFocus: "#0e2a5d",
    purple: "#201e5b",
    purpleFocus: "#161542",
    sealoflexBlue: "#00539c",
    sealoflexBlueFocus: "#003c70",
    brandGreen: "#2aa94e",
    brandGreenInter: "#1f7a39",
    brandGreenInterFocus: "#1a6531"
};
//# sourceMappingURL=data:application/json;base64,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